export class ApplicationPathConstants {

	// ------------ Common ------------
	public static readonly NEW_ANALYSIS_PAGE_PATH: string = 'new-analysis';
	public static readonly GENERATE_REPORT = 'generate';
	public static readonly ERROR_PAGE_PATH: string = 'error';
	public static readonly EDIT_PAGE_PATH: string = 'edit';
	public static readonly PORTFOLIO_MONITORING_PATH = 'monitoring';


	// ------------ Portfolio Centre ------------
	public static readonly BPAS_ANALYSIS_PATH = 'analysis';
	public static readonly PC_NEW_ANALYSIS_PAGE_PATH: string = ApplicationPathConstants.NEW_ANALYSIS_PAGE_PATH;
	public static readonly PC_ANALYSIS_PATH = 'analysis';
	public static readonly PC_DASHBOARD_PAGE_PATH = 'dashboard';


	// ------------ Portfolio Editor ------------
	public static readonly PORTFOLIO_EDITOR_PATH = 'portfolio-editor';
	public static readonly PE_REALLOCATE_VIEW_PATH = 'portfolio-editor/reallocate';
	public static readonly PORTFOLIO_EDITOR_PATHS = {
		EDIT: 'edit',
		HOLDINGS: 'holdings',
		HOLDINGS_RESOLUTION: 'correct-holdings'
	};

	public static readonly MODELS_BROWSE_PATHS = {
		FAMILY: '/family',
		FAMILIES: '/families',
		FUND_PERFORMANCE: '/fund-performance'
	};

	// ------------ Scenario Tester ------------
	public static readonly SCENARIO_ANALYSIS_PAGE_PATH: string = 'scenario-analysis';
	public static readonly SCENARIO_TESTER_ANALYSE: string = 'analyse';

	// ------------ CMA ------------
	public static readonly CMA_ANALYSIS_PATH = 'analysis';
	public static CMA_ESTIMATOR_PATHS = {
		NEW_ANALYSIS: ApplicationPathConstants.NEW_ANALYSIS_PAGE_PATH,
		PORTFOLIO_EDITOR: ApplicationPathConstants.PORTFOLIO_EDITOR_PATH,
		ANALYSIS: 'analysis',
		STEP_1: 'step-1',
		STEP_2: 'step-2',
		STEP_3: 'step-3'
	};

	// ------------ 360 Evaluator / PC ------------
	public static readonly HOLDINGS_CHARACTERISTICS_TAB_PATH: string = 'holdings-characteristics';
	public static readonly DETAILS_PAGE_PATH: string = 'details';
	public static readonly COMPARE_PAGE_PATH: string = 'compare';
	public static readonly REBALANCE_PAGE_PATH: string = 'rebalance';
	public static readonly REBALANCE_CHECK_PAGE_PATH: string = 'rebalance-check';
	public static readonly PEER_COMPARISON_PATH: string = 'peer-comparison';
	public static readonly OVERVIEW_TAB_PATH: string = 'overview';

	// ------------ Used for redirect from other tools to PA ------------
	public static readonly PA_PATHS = {
		OVERVIEW: 'analysis/overview',
		GENERATE: 'generate',
		EDIT: 'edit'
	};

	// ------------ Used for redirect from other tools to Tax  ------------
	public static readonly TAX_PATHS = {
		ESTIMATED_CAPITAL_GAINS: 'analysis/estimated-capital-gains',
		ANALYSIS: '/analysis/'
	};

	// ------------ Used for redirect from other tools to PC  ------------
	public static readonly PC_PATHS = {
		OVERVIEW: 'analysis/overview'
	};

	// ------------ Used for redirect from other tools to CMA  ------------
	public static readonly CMA_PATHS = {
		STEP_1: 'analysis/step-1'
	};

	// ------------ 360 Evaluator tab paths ------------
	public static readonly PORTFOLIO_ANALYSIS_PATHS = {
		COMMENTARY: 'commentary',
		COMPOSITION: 'characteristics',
		HOLDINGS_CHARACTERISTICS: 'holdings-characteristics',
		HOME: 'portfolio-analyser',
		INSIGHTS: 'insights',
		OVERVIEW: 'overview',
		PEER_COMPARISON: 'peer-comparison',
		PERFORMANCE: 'performance',
		RISK: 'decoding-risk',
		SCENARIO_ANALYSIS: 'scenario-analysis',
		ESG: 'esg'
		// COMPOSITION: 'composition',
		// TAX: 'tax-opportunities',
	};

	// ------------ SMA ------------
	public static readonly TTA_RESULT_VIEW_PATH = 'analysis/step4';

	// ----------------iRetire Paths------------------
	public static readonly IRETIRE_PATHS = {
		INPUTS: 'inputs',
		CLIENT_NAME: ':clientName',
		INPUTS_WITH_DEFAULT_CLIENT_NAME: 'blackrock/inputs',
		RESULTS: 'results',
		INCOME: 'income',
		ALLOCATIONS: 'allocations',
		RISK_ANALYTICS: 'risk-analytics'
	};

	// ----------------Investment Quality Paths------------------
	public static readonly INVESTMENT_QUALITY_PATHS = {
		ANALYSIS: 'analysis',
		SUMMARY: 'summary',
		INVESTMENT_DETAILS: 'investment-details'
	};

	// ----------------Professional Investors Paths----------------
	public static readonly PROFESSIONAL_INVESTORS_PATHS = {
		PORTFOLIO_WORKBENCH: 'portfolio-workbench',
		PORTFOLIO_WORKBENCH_EDITOR: 'portfolio-workbench-editor',
		ETF_PRE_TRADE: 'etf-pre-trade'
	};

	// ----------------Models Experience Paths------------------
	public static readonly MODELS_EXPERIENCE_PATHS = {
		HOME: '',
		FIND_AND_COMPARE: 'find-and-compare-models',
		REBALANCE: 'rebalance-resources',
		HOW_TO_INVEST: 'how-to-invest',
		FAMILY: 'family',
		FUND_PERFORMANCE: 'fund-performance'
	};

	// ----------------AC Portfolio Library Paths------------------
	public static readonly AC_PORTFOLIO_LIBRARY_PATHS = {
		PORTFOLIO_LIBRARY: 'portfolio-library',
		MONITORING: 'monitoring'
	};

	// ----------------Partner Flow Paths------------------
	public static readonly PARTNER_FLOW_PATHS = {
		HOLDINGS_RESOLUTIONS: 'holdings-resolution'
	};

	public static readonly ACT2_PATHS = {
		FIND_AND_COMPARE_PAGE: 'https://www.blackrock.com/advisor-center-360/?location=/model-evaluator/blackrock_models/0&pkg=UAP_DLY#/model-evaluator/blackrock_models/0',
		MODEL_FAMILY_DETAILS: 'https://www.blackrock.com/advisor-center-360/?location=/model-evaluator/model-family-details/model/blackrock_models/0/$$pathName$$&fg=metadata.account.FAMILY_ID:$$familyId$$:IN,metadata.account.SUBTYPE:BLK:IN&pkg=UAP_DLY#/model-evaluator/model-family-details/model/blackrock_models/0/$$pathName$$',
		FUND_PERFORMANCE_AND_FEES: 'https://www.blackrock.com/advisor-center-360/?location=/model-evaluator/model-family-details/model/blackrock_models/0/fund-performance-fees&fg=metadata.account.FAMILY_ID:$$familyId$$:IN,metadata.account.SUBTYPE:BLK:IN&pkg=UAP_DLY#/model-evaluator/model-family-details/model/blackrock_models/0/fund-performance-fees',
		COMPARE_URL: 'https://www.blackrock.com/advisor-center-360/?location=/model-evaluator/blackrock_models/0/comparison/overview&comparisonIds=$$modelIds$$&pkg=UAP_DLY#/model-evaluator/blackrock_models/0/comparison/overview',
		DEEP_DIVE_URL: 'https://www.blackrock.com/advisor-center-360/?location=/model-evaluator/model-family-details/model/blackrock_models/0/latest-holdings&fg=metadata.account.FAMILY_ID:$$familyId$$:IN,metadata.account.SUBTYPE:BLK:IN&pkg=UAP_DLY#/model-evaluator/model-family-details/model/blackrock_models/0/latest-holdings',
		PORTFOLIO_ANALYSER_URL: 'https://www.blackrock.com/advisor-center-360/?location=/comparison/overview&comparisonIds=MODEL_ID:WTS_$$portfolioId$$&portfolioSelection=true&pkg=UAP_DLY#/comparison/overview',
		FUND_PERFORMANCE_AND_FEES_CMS: 'https://www.blackrock.com/advisor-center-360/?location=/model-evaluator/model-family-details/entitledModel/my_custom_models/0/fund-performance-fees&fg=metadata.account.FAMILY_ID:$$familyId$$:IN,metadata.account.SUBTYPE:CMS|BLK:IN&pkg=UAP_DLY#/model-evaluator/model-family-details/entitledModel/my_custom_models/0/fund-performance-fees',
		MODEL_FAMILY_DETAILS_CMS: 'https://www.blackrock.com/advisor-center-360/?location=/model-evaluator/model-family-details/entitledModel/my_custom_models/0/$$pathName$$&fg=metadata.account.FAMILY_ID:$$familyId$$:IN,metadata.account.SUBTYPE:CMS|BLK:IN&pkg=UAP_DLY#/model-evaluator/model-family-details/entitledModel/my_custom_models/0/$$pathName$$'
	};
}
